import React, { useEffect, useState } from "react";
import Category_card from "./category_card/Category_card";
import { useDispatch, useSelector } from "react-redux";
import Banner_Btn_Component from "../home/banner_btn_component/Banner_Btn_Component";
import { useNavigate } from "react-router-dom";
import { getAllCategories } from "../../features/master/masterSlice";
import { getAddBanner, getHomeBanner } from "../../features/home/homeSlice";

const Category = ({ product }) => {
  const navigate = useNavigate();

  const data1 = [
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
  ];

  const data2 = [
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
    { img: "/assets/images/products/img1.png", label: "Vegetables" },
    { img: "/assets/images/products/img2.png", label: "Fresh Fruits" },
  ];

  const dispatch = useDispatch();
  const categories = useSelector((state) => state.master.categories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

const addBanners = useSelector((state) => state.home.addBanners)
 
  useEffect(() => {
    dispatch(getAddBanner());
  }, []);
  return (
    <section className="Shop">
      <div className="container">
        <div className="row">
          {categories.slice(0, 6).map((item, index) => (
            <div className="col-md-6" key={index}>
              <Category_card
                img={process.env.REACT_APP_IMG_URL + item.image}
                label={item.name}
                onClick={() =>
                  navigate(
                    `/product-listing/${
                      item?.id
                    }?category_name=${encodeURIComponent(
                      item?.name
                    )}&category_image=${encodeURIComponent(item?.image)}`
                  )
                }
              />
            </div>
          ))}
        </div>
        {addBanners?.[1]?.image ? (
          <Banner_Btn_Component addBanners={addBanners} />
        ) : null}

        <div className="row">
          {categories.slice(6).map((item, index) => (
            <div className="col-md-6" key={index}>
              <Category_card
                img={process.env.REACT_APP_IMG_URL + item.image}
                label={item.name}
                onClick={() =>
                  navigate(
                    `/product-listing/${
                      item?.id
                    }?category_name=${encodeURIComponent(
                      item?.name
                    )}&category_image=${encodeURIComponent(item?.image)}`
                  )
                }
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Category;
